import React, { useEffect } from 'react';
import Navbar from '@/components/layout/Navbar';
import Hero from '@/components/sections/Hero';
import Services from '@/components/sections/Services';
import Projects from '@/components/sections/Projects';
import CollabApp from '@/components/sections/CollabApp';
import Functionalities from '@/components/sections/Functionalities';
import EstimationForm from '@/components/sections/EstimationForm';
import Testimonials from '@/components/sections/Testimonials';
import Blog from '@/components/sections/Blog';
import BookingModule from '@/components/sections/BookingModule';
import SEO from '@/components/SEO';
import FAQ from '@/components/ui/FAQ';

const faqItems = [
  {
    question: "Quels types de projets développez-vous ?",
    answer: "Nous développons une large gamme de solutions numériques, incluant des applications SaaS, des applications mobiles, des systèmes d'automatisation, des marketplaces et des solutions web sur mesure. Notre expertise s'étend à tous les aspects du développement, de la conception à la maintenance."
  },
  {
    question: "Comment se déroule le processus de développement ?",
    answer: "Notre processus de développement est agile et collaboratif. Nous commençons par une phase de découverte pour comprendre vos besoins, puis nous développons un MVP rapidement. Ensuite, nous itérons avec des cycles courts de développement, en vous impliquant à chaque étape pour garantir que le produit final correspond parfaitement à vos attentes."
  },
  {
    question: "Combien de temps faut-il pour développer un projet ?",
    answer: "La durée dépend de la complexité du projet. Un MVP peut être développé en quelques semaines, tandis qu'une solution complète peut prendre plusieurs mois. Nous privilégions une approche itérative qui permet de lancer rapidement une première version fonctionnelle, puis de l'améliorer progressivement."
  },
  {
    question: "Proposez-vous un support après le lancement ?",
    answer: "Oui, nous offrons un support complet après le lancement. Cela inclut la maintenance technique, les mises à jour de sécurité, l'optimisation des performances, et l'évolution fonctionnelle de votre solution. Nous restons à vos côtés pour assurer le succès à long terme de votre projet."
  },
  {
    question: "Quelles technologies utilisez-vous ?",
    answer: "Nous utilisons les technologies les plus modernes et éprouvées du marché. Pour le frontend : React, Next.js, TypeScript et Tailwind CSS. Pour le backend : Django, Node.js et GraphQL. Nous déployons sur le cloud (AWS, Vercel) et utilisons des pratiques DevOps avancées pour garantir qualité et performance."
  }
];

const Index = () => {
  useEffect(() => {
    // Set document title and language attribute for SEO
    document.title = "Orcsys | Développement d'applications mobiles, web et métier pour entrepreneurs et startups";
    document.documentElement.lang = 'fr';
  }, []);

  return (
    <>
      <SEO 
        title="Innovez avec confiance - Développement d'applications mobiles, web et métier pour entrepreneurs et startups"
        description="Orcsys - Votre partenaire en développement de solutions numériques sur mesure. Expertise en applications mobiles et web, automatisation de processus et transformation digitale. Créez, innovez et développez votre projet avec une équipe experte."
        keywords="développement web, SaaS, applications mobiles, automatisation, marketplace, solutions numériques, Orcsys, développement sur mesure, transformation digitale, innovation technologique, startup, applications métier"
        url="https://innov.orcsys.fr"
        image="https://innov.orcsys.fr/images/home-preview.jpg"
        type="website"
      />
      <div className="min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <Projects />
          <CollabApp />
          <Functionalities />
          <FAQ 
            title="Questions Fréquentes"
            subtitle="Découvrez comment nous pouvons vous aider à concrétiser votre projet"
            items={faqItems}
            className="bg-slate-50"
          />
          <EstimationForm />
          {/* <Testimonials /> */}
          {/* <Blog /> */}
          <BookingModule />
        </main>
      </div>
    </>
  );
};

export default Index;
